import { render, staticRenderFns } from "./CorrectionEstado.vue?vue&type=template&id=dd6993a8&scoped=true&"
import script from "./CorrectionEstado.vue?vue&type=script&lang=js&"
export * from "./CorrectionEstado.vue?vue&type=script&lang=js&"
import style0 from "./CorrectionEstado.vue?vue&type=style&index=0&id=dd6993a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6993a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
  VList,
  VListTile,
  VListTileTitle,
  VMenu,
})
